import { createServiceHTTPClientProvider, createBoundServiceQueryHooksCreator, createBoundServiceMutationHookCreator } from "@airhelp/service-utils";
import { e as fetchBrand, b as createUser, h as fetchCurrentUserProfile, j as fetchTrustpilotScore, u as confirmPayout, w as createCreditCardTransfer, z as fetchCurrencyExchangeRateForTargetCountry, C as fetchPaymentReferenceData, H as fetchPayoutClaim, K as postBankTransferDetails, M as postChequeDetails, O as postPaypalDetails, Q as putPayoutDetails, o as fetchAirlines, s as fetchAirports, T as fetchClaim, V as fetchClaimEnquiries, X as deleteClaimEnquiry, _ as updateUserProfile, a0 as acceptMarketingConsent } from "./accept-marketing-consent-BCpf7RLc.js";
import { useQueryClient } from "@tanstack/react-query";
const [WebappHTTPClientProvider, useWebappHTTPClient] = createServiceHTTPClientProvider({
  name: "Webapp"
});
const WEBAPP_REACT_QUERY_KEY_PREFIX = "webapp";
const createWebappQueryHooks = createBoundServiceQueryHooksCreator({
  queryKeyPrefix: WEBAPP_REACT_QUERY_KEY_PREFIX,
  useClient: useWebappHTTPClient
});
const createWebappMutationHook = createBoundServiceMutationHookCreator({
  useClient: useWebappHTTPClient
});
const [useBrand, useBrandSuspense] = createWebappQueryHooks({
  queryFn: fetchBrand,
  queryKey: ["brand"]
});
const useCreateUser = createWebappMutationHook({
  mutationFn: createUser
});
const [useCurrentUserProfile, useCurrentUserProfileSuspense] = createWebappQueryHooks({
  queryFn: fetchCurrentUserProfile,
  queryKey: ["current-user-profile"]
});
const [useTrustpilotScore, useTrustpilotScoreSuspense] = createWebappQueryHooks({
  queryFn: fetchTrustpilotScore,
  queryKey: ["trustpilot-score"]
});
const useConfirmPayout = createWebappMutationHook({
  mutationFn: confirmPayout
});
const useCreateCreditCardTransfer = createWebappMutationHook({
  mutationFn: createCreditCardTransfer
});
const [
  useCurrencyExchangeRateForTargetCountry,
  useCurrencyExchangeRateForTargetCountrySuspense
] = createWebappQueryHooks({
  queryFn: fetchCurrencyExchangeRateForTargetCountry,
  queryKey: ["currency-exchange-rate-for-target-country"]
});
const [usePaymentReferenceData, usePaymentReferenceDataSuspense] = createWebappQueryHooks({
  queryFn: fetchPaymentReferenceData,
  queryKey: ["payment-reference-data"]
});
const [usePayoutClaim, usePayoutClaimSuspense] = createWebappQueryHooks({
  queryFn: fetchPayoutClaim,
  queryKey: ["payout-claim"]
});
const useUpdateBankTransferDetails = createWebappMutationHook({
  mutationFn: postBankTransferDetails
});
const useUpdateChequeDetails = createWebappMutationHook({
  mutationFn: postChequeDetails
});
const useUpdatePaypalDetails = createWebappMutationHook({
  mutationFn: postPaypalDetails
});
const useUpdatePaymentDetails = createWebappMutationHook({
  mutationFn: putPayoutDetails
});
const [useAirlines, useAirlinesSuspense] = createWebappQueryHooks({
  queryFn: fetchAirlines,
  queryKey: ["airlines"]
});
const [useAirports, useAirportsSuspense] = createWebappQueryHooks({
  queryFn: fetchAirports,
  queryKey: ["airports"]
});
const [useClaim, useClaimSuspense] = createWebappQueryHooks({
  queryFn: fetchClaim,
  queryKey: ["claim"]
});
const [useClaimEnquiries, useClaimEnquiriesSuspense] = createWebappQueryHooks({
  queryFn: fetchClaimEnquiries,
  queryKey: ["claim-enquiries"]
});
const useInternalDeleteClaimEnquiry = createWebappMutationHook({
  mutationFn: deleteClaimEnquiry
});
function useDeleteClaimEnquiry(options) {
  const queryClient = useQueryClient();
  return useInternalDeleteClaimEnquiry({
    async onSuccess(data, params, context) {
      var _a;
      await queryClient.invalidateQueries({
        queryKey: useClaimEnquiries.getQueryKey()
      });
      queryClient.removeQueries({
        queryKey: useClaimEnquiries.getQueryKey()
      });
      await ((_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data, params, context));
    }
  });
}
const useUpdateUserProfile = createWebappMutationHook({
  mutationFn: updateUserProfile
});
const useAcceptMarketingConsent = createWebappMutationHook({
  mutationFn: acceptMarketingConsent
});
export {
  WEBAPP_REACT_QUERY_KEY_PREFIX,
  WebappHTTPClientProvider,
  useAcceptMarketingConsent,
  useAirlines,
  useAirlinesSuspense,
  useAirports,
  useAirportsSuspense,
  useBrand,
  useBrandSuspense,
  useClaim,
  useClaimEnquiries,
  useClaimEnquiriesSuspense,
  useClaimSuspense,
  useConfirmPayout,
  useCreateCreditCardTransfer,
  useCreateUser,
  useCurrencyExchangeRateForTargetCountry,
  useCurrencyExchangeRateForTargetCountrySuspense,
  useCurrentUserProfile,
  useCurrentUserProfileSuspense,
  useDeleteClaimEnquiry,
  usePaymentReferenceData,
  usePaymentReferenceDataSuspense,
  usePayoutClaim,
  usePayoutClaimSuspense,
  useTrustpilotScore,
  useTrustpilotScoreSuspense,
  useUpdateBankTransferDetails,
  useUpdateChequeDetails,
  useUpdatePaymentDetails,
  useUpdatePaypalDetails,
  useUpdateUserProfile,
  useWebappHTTPClient
};
//# sourceMappingURL=react.js.map
